import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/** Widgets del dashboard cuya visibilidad se personaliza (modal del sidebar). */
export type DashboardWidget =
  | "quickActions"
  | "recentRequests"
  | "kpiRow1"
  | "kpiRow2"
  | "stageDistribution";

export type WidgetVisibility = Record<DashboardWidget, boolean>;

const DEFAULT: WidgetVisibility = {
  quickActions: true,
  recentRequests: true,
  kpiRow1: true,
  kpiRow2: true,
  stageDistribution: true,
};

interface DashboardLayoutState {
  widgets: WidgetVisibility;
  toggle: (key: DashboardWidget) => void;
  reset: () => void;
}

/**
 * Visibilidad de los módulos del dashboard · personalizable desde el modal
 * "Customize Layout" (botón del sidebar). Persistido por navegador. Store
 * compartido para que el sidebar (que abre el modal) y el dashboard (que
 * renderiza los widgets) lean la misma fuente.
 */
export const useDashboardLayoutStore = create<DashboardLayoutState>()(
  persist(
    (set) => ({
      widgets: DEFAULT,
      toggle: (key) => set((s) => ({ widgets: { ...s.widgets, [key]: !s.widgets[key] } })),
      reset: () => set({ widgets: DEFAULT }),
    }),
    { name: "dashboard-widgets-v1", storage: createJSONStorage(() => localStorage) },
  ),
);
